//
//
//
//
//
// import marked from "marked";
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  } // computed: {
  //   compiledText() {
  //     if (this.spec.format == "markdown") {
  //       return marked(this.spec.text, { sanitize: true });
  //     } else {
  //       return this.spec.text;
  //     }
  //   }
  // }

};